import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import PublicNav from "@/components/PublicNav";
import PublicFooter from "@/components/PublicFooter";
import usePageMeta from "@/hooks/usePageMeta";

export default function PageView() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);
  usePageMeta(page?.title || "Page", page?.meta_description || "");

  useEffect(() => {
    setPage(null);
    setNotFound(false);
    api.get(`/pages/${slug}`).then((r) => setPage(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="min-h-screen bg-white flex flex-col">
        <PublicNav />
        <div className="flex-1 p-10 max-w-2xl mx-auto text-center">
          <h1 className="text-3xl font-bold text-slate-900">Page not found</h1>
          <p className="text-slate-500 mt-3">The page you are looking for does not exist.</p>
          <Link to="/" className="text-blue-700 underline mt-4 inline-block">← Back to home</Link>
        </div>
        <PublicFooter />
      </div>
    );
  }

  if (!page) {
    return (
      <div className="min-h-screen bg-white">
        <PublicNav />
        <div className="p-10 text-slate-500">Loading…</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid={`page-${page.slug}`}>
      <PublicNav />
      <main className="flex-1 mx-auto max-w-3xl px-6 py-14 w-full">
        <h1 className="text-4xl sm:text-5xl font-black tracking-tighter text-slate-900 mb-4" data-testid="page-title">
          {page.title}
        </h1>
        {page.updated_at && (
          <p className="text-xs text-slate-400 mb-8">
            Last updated {new Date(page.updated_at).toLocaleDateString()}
          </p>
        )}
        <article
          className="prose prose-slate max-w-none text-slate-700 leading-relaxed
                     prose-headings:text-slate-900 prose-headings:font-bold
                     prose-h2:mt-8 prose-h2:mb-3 prose-h2:text-2xl
                     prose-h3:mt-6 prose-h3:mb-2 prose-h3:text-xl
                     prose-p:my-4 prose-a:text-blue-700 prose-strong:text-slate-900
                     prose-ul:my-4 prose-li:my-1"
          data-testid="page-content"
          dangerouslySetInnerHTML={{ __html: page.content || "" }}
        />
      </main>
      <PublicFooter />
    </div>
  );
}
